import React from 'react';
import { useTranslation } from 'react-i18next';

const Segments: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="container-custom section-padding">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-mypa-blue mb-4">
          {t("segments.title")}
        </h1>
        <p className="text-xl max-w-3xl mx-auto">
          {t("segments.subtitle")}
        </p>
      </div>
      
      {/* Introduction */}
      <section className="mb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-mypa-green mb-6">{t("segments.intro.title")}</h2>
            <p className="text-lg mb-4">
              {t("segments.intro.description")}
            </p>
            <p className="text-lg">
              {t("segments.intro.description")}
            </p>
          </div>
          <div className="bg-mypa-light p-8 rounded-lg shadow-md">
            <h3 className="text-xl font-bold text-mypa-blue mb-4">{t("segments.intro.title")}</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <div className="bg-mypa-green rounded-full p-1 mr-3 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span>{t("segments.intro.point1")}</span>
              </li>
              <li className="flex items-start">
                <div className="bg-mypa-green rounded-full p-1 mr-3 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span>{t("segments.intro.point2")}</span>
              </li>
              <li className="flex items-start">
                <div className="bg-mypa-green rounded-full p-1 mr-3 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span>{t("segments.intro.point3")}</span>
              </li>
              <li className="flex items-start">
                <div className="bg-mypa-green rounded-full p-1 mr-3 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span>{t("segments.intro.point4")}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      
      {/* Segments Section */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-mypa-blue mb-8 text-center">{t("segments.solutions.title")}</h2>
        
        {/* Exporters Segment */}
        <div className="bg-white p-8 rounded-lg shadow-md mb-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-1">
              <div className="bg-mypa-light p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-mypa-blue mb-4">{t("segments.exporters.title")}</h3>
                <p className="mb-4">{t("segments.exporters.description")}</p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-start">
                    <div className="text-mypa-green mr-2">✓</div>
                    <span>{t("segments.exporters.point1")}</span>
                  </li>
                  <li className="flex items-start">
                    <div className="text-mypa-green mr-2">✓</div>
                    <span>{t("segments.exporters.point2")}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:col-span-2">
              <h4 className="text-xl font-bold text-mypa-green mb-4">{t("segments.exporters.solution.title")}</h4>
              <p className="mb-4">
                {t("segments.exporters.solution.description")}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.exporters.solution.feature1.title")}</h5>
                  <p>{t("segments.exporters.solution.feature1.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.exporters.solution.feature2.title")}</h5>
                  <p>{t("segments.exporters.solution.feature2.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.exporters.solution.feature3.title")}</h5>
                  <p>{t("segments.exporters.solution.feature3.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.exporters.solution.feature4.title")}</h5>
                  <p>{t("segments.exporters.solution.feature4.description")}</p>
                </div>
              </div>
              
              {/* Recommendation Box */}
              <div className="bg-mypa-green bg-opacity-10 p-6 rounded-lg border-l-4 border-mypa-green mb-6">
                <h5 className="font-bold text-mypa-green mb-2">{t("segments.exporters.recommendation.title")}</h5>
                <p className="font-medium mb-1">{t("segments.exporters.recommendation.description")}</p>
                <p className="text-sm">{t("segments.exporters.recommendation.details")}</p>
              </div>
              
              <a href="/contact" className="btn-primary">{t("common.learn_more")}</a>
            </div>
          </div>
        </div>
        
        {/* Large Companies Segment */}
        <div className="bg-white p-8 rounded-lg shadow-md mb-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-1">
              <div className="bg-mypa-light p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-mypa-blue mb-4">{t("segments.large.title")}</h3>
                <p className="mb-4">{t("segments.large.description")}</p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-start">
                    <div className="text-mypa-green mr-2">✓</div>
                    <span>{t("segments.large.point1")}</span>
                  </li>
                  <li className="flex items-start">
                    <div className="text-mypa-green mr-2">✓</div>
                    <span>{t("segments.large.point2")}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:col-span-2">
              <h4 className="text-xl font-bold text-mypa-green mb-4">{t("segments.large.solution.title")}</h4>
              <p className="mb-4">
                {t("segments.large.solution.description")}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.large.solution.feature1.title")}</h5>
                  <p>{t("segments.large.solution.feature1.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.large.solution.feature2.title")}</h5>
                  <p>{t("segments.large.solution.feature2.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.large.solution.feature3.title")}</h5>
                  <p>{t("segments.large.solution.feature3.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.large.solution.feature4.title")}</h5>
                  <p>{t("segments.large.solution.feature4.description")}</p>
                </div>
              </div>
              
              {/* Recommendation Box */}
              <div className="bg-mypa-green bg-opacity-10 p-6 rounded-lg border-l-4 border-mypa-green mb-6">
                <h5 className="font-bold text-mypa-green mb-2">{t("segments.large.recommendation.title")}</h5>
                <p className="font-medium mb-1">{t("segments.large.recommendation.description")}</p>
                <p className="text-sm">{t("segments.large.recommendation.details")}</p>
              </div>
              
              <a href="/contact" className="btn-primary">{t("common.learn_more")}</a>
            </div>
          </div>
        </div>
        
        {/* Committed SMEs Segment */}
        <div className="bg-white p-8 rounded-lg shadow-md mb-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-1">
              <div className="bg-mypa-light p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-mypa-blue mb-4">{t("segments.sme.title")}</h3>
                <p className="mb-4">{t("segments.sme.description")}</p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-start">
                    <div className="text-mypa-green mr-2">✓</div>
                    <span>{t("segments.sme.point1")}</span>
                  </li>
                  <li className="flex items-start">
                    <div className="text-mypa-green mr-2">✓</div>
                    <span>{t("segments.sme.point2")}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:col-span-2">
              <h4 className="text-xl font-bold text-mypa-green mb-4">{t("segments.sme.solution.title")}</h4>
              <p className="mb-4">
                {t("segments.sme.solution.description")}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.sme.solution.feature1.title")}</h5>
                  <p>{t("segments.sme.solution.feature1.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.sme.solution.feature2.title")}</h5>
                  <p>{t("segments.sme.solution.feature2.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.sme.solution.feature3.title")}</h5>
                  <p>{t("segments.sme.solution.feature3.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.sme.solution.feature4.title")}</h5>
                  <p>{t("segments.sme.solution.feature4.description")}</p>
                </div>
              </div>
              
              {/* Recommendation Box */}
              <div className="bg-mypa-green bg-opacity-10 p-6 rounded-lg border-l-4 border-mypa-green mb-6">
                <h5 className="font-bold text-mypa-green mb-2">{t("segments.sme.recommendation.title")}</h5>
                <p className="font-medium mb-1">{t("segments.sme.recommendation.description")}</p>
                <p className="text-sm">{t("segments.sme.recommendation.details")}</p>
              </div>
              
              <a href="/contact" className="btn-primary">{t("common.learn_more")}</a>
            </div>
          </div>
        </div>
        
        {/* Small Businesses Segment */}
        <div className="bg-white p-8 rounded-lg shadow-md">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-1">
              <div className="bg-mypa-light p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-mypa-blue mb-4">{t("segments.vsmall.title")}</h3>
                <p className="mb-4">{t("segments.vsmall.description")}</p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-start">
                    <div className="text-mypa-green mr-2">✓</div>
                    <span>{t("segments.vsmall.point1")}</span>
                  </li>
                  <li className="flex items-start">
                    <div className="text-mypa-green mr-2">✓</div>
                    <span>{t("segments.vsmall.point2")}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:col-span-2">
              <h4 className="text-xl font-bold text-mypa-green mb-4">{t("segments.vsmall.solution.title")}</h4>
              <p className="mb-4">
                {t("segments.vsmall.solution.description")}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.vsmall.solution.feature1.title")}</h5>
                  <p>{t("segments.vsmall.solution.feature1.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.vsmall.solution.feature2.title")}</h5>
                  <p>{t("segments.vsmall.solution.feature2.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.vsmall.solution.feature3.title")}</h5>
                  <p>{t("segments.vsmall.solution.feature3.description")}</p>
                </div>
                <div className="bg-mypa-light p-4 rounded">
                  <h5 className="font-bold mb-2">{t("segments.vsmall.solution.feature4.title")}</h5>
                  <p>{t("segments.vsmall.solution.feature4.description")}</p>
                </div>
              </div>
              
              {/* Recommendation Box */}
              <div className="bg-mypa-green bg-opacity-10 p-6 rounded-lg border-l-4 border-mypa-green mb-6">
                <h5 className="font-bold text-mypa-green mb-2">{t("segments.vsmall.recommendation.title")}</h5>
                <p className="font-medium mb-1">{t("segments.vsmall.recommendation.description")}</p>
                <p className="text-sm">{t("segments.vsmall.recommendation.details")}</p>
              </div>
              
              <a href="/contact" className="btn-primary">{t("common.learn_more")}</a>
            </div>
          </div>
        </div>
      </section>
      
      {/* Testimonials Section */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-mypa-blue mb-8 text-center">{t("segments.testimonials.title")}</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-mypa-light rounded-full flex items-center justify-center text-mypa-green font-bold text-xl mr-4">A</div>
              <div>
                <h3 className="font-bold">{t("segments.testimonials.testimonial1.name")}</h3>
                <p className="text-sm text-gray-600">{t("segments.testimonials.testimonial1.role")}</p>
              </div>
            </div>
            <p className="italic">
              {t("segments.testimonials.testimonial1.quote")}
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-mypa-light rounded-full flex items-center justify-center text-mypa-green font-bold text-xl mr-4">S</div>
              <div>
                <h3 className="font-bold">{t("segments.testimonials.testimonial2.name")}</h3>
                <p className="text-sm text-gray-600">{t("segments.testimonials.testimonial2.role")}</p>
              </div>
            </div>
            <p className="italic">
              {t("segments.testimonials.testimonial2.quote")}
            </p>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="text-center">
        <h2 className="text-3xl font-bold text-mypa-blue mb-4">{t("segments.cta.title")}</h2>
        <p className="text-xl max-w-3xl mx-auto mb-8">
          {t("segments.cta.description")}
        </p>
        <a href="/contact" className="btn-primary">{t("segments.cta.button")}</a>
      </section>
    </div>
  );
};

export default Segments;
